import { render, staticRenderFns } from "./OrderListPage.vue?vue&type=template&id=5d99f1ce&scoped=true&"
import script from "./OrderListPage.vue?vue&type=script&lang=js&"
export * from "./OrderListPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderListPage.vue?vue&type=style&index=0&id=5d99f1ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99f1ce",
  null
  
)

export default component.exports